import { ModalHeader, ModalHeaderProps } from '@chakra-ui/react';
import React from 'react';

export const CmModalHeader: React.FC<ModalHeaderProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <ModalHeader {...rest}>{children}</ModalHeader>;
};
